import { StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import { spacing } from '@pletly/ui';
import { AddNewButton } from '%components/AddNewButton';
import FileIcon from './file.svg';

export const PickButton = ({ onPress }: { onPress: () => void }) => {
	const { t } = useTranslation();

	return (
		<AddNewButton
			testID="add-file-button"
			accessoryLeft={<FileIcon />}
			style={styles.button}
			onPress={onPress}
		>
			{t('post.add-file')}
		</AddNewButton>
	);
};

const styles = StyleSheet.create({
	button: {
		marginTop: spacing(),
		// @ts-expect-error Valid for web
		width: 'fit-content',
	},
});
